<template lang="pug">
div
	lessonHeader
	stepTitle
	v-layout.Escenario1-layout(row wrap)
		v-flex(xl6 lg6 md6 sm6)
			imageLoader
		v-flex.Escenario1-rigth(xl6 lg6 md6 sm6)
			initialText.Escenario1-text
	buttonNext2
	lessonFooter
</template>

<script>

import lessonHeader from "@/components/lesson-header/lesson-header";
import stepTitle from '@/components/step-title/step-title'
import stepTitle2 from '@/components/step-title2/step-title2'
import buttonNext2 from '@/components/button-next/button-next2'
import initialText from '@/components/initial-text/initial-text'
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import imageLoader from "@/components/image-loader/image-loader";

export default {
  name: 'Escenario1',
  components:{
  	lessonHeader,
    stepTitle,
    stepTitle2,
    buttonNext2,
    initialText,
    lessonFooter,
    imageLoader
  }
}
</script>

<style scoped>
@import 'escenario1.scss';
</style>